import {
  React,
  useEffect,
  useState,
  useMemo,
} from 'react';
import { Row, Col } from 'react-bootstrap';
import RefreshDocList from './DocList/RefreshDocList';
import '../components/Filters/Filters.scss';
import TagsWithFilters from './TagsWithFilters';
import ProfileTabs from './ProfileTabs';

const TabProfileGroup = ({ profiles, name, title, path }) => {
  const [activeGroupKey, setActiveGroupKey] = useState('');
  const [activeSubCveKey, setActiveSubCveKey] = useState('recommendations');
  const [activeSubNewsKey, setActiveSubNewsKey] = useState('recommendations');

  const routes = useMemo(
    () => ({
      [name]: {
        cve: `/${name}/cve`,
        news: `/${name}/news`,
        podcasts: `/${name}/podcasts`,
      },
    }),
    [name]
  );

  const newsProfile = profiles[`${name}_news`];
  const cveProfile = profiles[`${name}_cve`];
  const podcastProfile = profiles[`${name}_podcasts`];
  const mitreProfile = profiles[`mitre`];

  useEffect(() => {
    if (path.includes(routes[name].news)) {
      setActiveGroupKey('news');
    } else if (path.includes(routes[name].cve)) {
      setActiveGroupKey('cve');
    } else if (path.includes(routes[name].podcasts)) {
      setActiveGroupKey('podcasts');
    }
  }, [path, name, routes]);

  const profile = profiles[`${name}_${activeGroupKey}`];
  return (
    <div data-testid='news-wrapper' className='m-0'>
      <Row>
        <Col md={12}>
          <h3 className='mytools_heading'>{title}</h3>
        </Col>
        <Col md={12}>
          {(profile?.roles.indexOf('curator') > -1 && 
            ((activeGroupKey === 'news' && activeSubNewsKey === 'recommendations') || 
              (activeGroupKey === 'podcasts' && activeSubNewsKey === 'recommendations') || 
             (activeGroupKey === 'cve' && activeSubCveKey === 'recommendations'))) && <TagsWithFilters profiles={profiles} name={name} activeGroupKey={activeGroupKey} />}
        </Col>
      </Row>
      <Row>
        <Col md={12}>
          <div className='position-relative '>
            <RefreshDocList />
            <ProfileTabs
                newsProfile={newsProfile}
                podcastProfile={podcastProfile}
                cveProfile={cveProfile}
                mitreProfile={mitreProfile}
                routes={routes}
                name={name}
                activeGroupKey={activeGroupKey}
                activeSubNewsKey={activeSubNewsKey}
                setActiveSubNewsKey={setActiveSubNewsKey}
                activeSubCveKey={activeSubCveKey}
                setActiveSubCveKey={setActiveSubCveKey}
            />
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default TabProfileGroup;
